module.exports = __webpack_public_path__ + "static/media/label_gewenst.4abebbac.jpg";